import axios from "axios";
import { cropr } from "../adapter";
import { jwtClient } from "./authUtils";

export const REQUEST_ALL_STATIONS = "REQUEST_ALL_STATIONS";
const requestAllStations = () => {
  return {
    type: REQUEST_ALL_STATIONS,
  };
};

export const RECEIVE_ALL_STATIONS = "RECEIVE_ALL_STATIONS";
const receiveAllStations = (allStations) => {
  return {
    type: RECEIVE_ALL_STATIONS,
    items: allStations,
  };
};

export const FAILED_ALL_STATIONS = "FAILED_ALL_STATIONS";
const failedAllStations = () => {
  return {
    type: FAILED_ALL_STATIONS,
  };
};

export const fetchAllStations = (apiUrl) => {
  return async (dispatch) => {
    dispatch(requestAllStations());
    let allStationsCacheKey = "allStationsCache" + cropr.farm.id;
    let allStationsTimestampCacheKey = "allStationsTimestampCache" + cropr.farm.id;
    try {
      let responseText = window.localStorage.getItem(allStationsCacheKey);
      const timestampCache = window.localStorage.getItem(allStationsTimestampCacheKey);

      if (timestampCache) {
        const now = new Date();
        if (now.getTime() > parseInt(timestampCache) + 30 * 60 * 1000) {
          responseText = null;
        }
      } else {
        responseText = null;
      }

      let allStations;
      if (responseText) {
        allStations = JSON.parse(responseText);
      } else {
        var url = apiUrl + "/api/product/installation/raw/?no_advice=True";

        const response = await jwtClient.withJWT(async (jwt) => {
          return axios.get(url, {
            headers: { Authorization: "JWT " + jwt },
          });
        });
        const now = new Date();
        window.localStorage.setItem(allStationsTimestampCacheKey, now.getTime().toString());
        window.localStorage.setItem(allStationsCacheKey, JSON.stringify(response.data));
        allStations = response.data;
      }
      return dispatch(receiveAllStations(allStations));
    } catch (err) {
      window.localStorage.removeItem(allStationsCacheKey);
      window.localStorage.removeItem(allStationsTimestampCacheKey);
      return dispatch(failedAllStations());
    }
  };
};
